// Imports
import Link from "../../menu-link/LinkHelper.jsx";

export default function ProjectsSlide({ data, navigate }) {

    return (
        <Link navigate={navigate} className='link card-link' href={data.slug} aria-label="See the project">
            <article className='nav-card'>
                <div className='card-group'>
                    <div className='card-background'>
                        <img src={data.imageSwiper} alt={data.title || ''} />
                    </div>
                    <div className='card-content'>
                        <div className='card-content-inner'>
                            <h3 className='card-content-title h3'>{data.title}</h3>
                        </div>
                    </div>
                </div>
            </article>
        </Link>
    )
}